import DatePicker from "react-date-picker/dist/entry.nostyle"
import { subYears } from "date-fns"

import isDate from "@src/utilities/is-date"

import "react-date-picker/dist/DatePicker.css"
import "react-calendar/dist/Calendar.css"

interface AccountBirthdayProps {
  birthDate?: string
  isUpdating: boolean
  onUpdateBirthDate: (value: Date | null) => Promise<void>
}
export default function AccountBirthday({
  birthDate,
  isUpdating,
  onUpdateBirthDate,
}: AccountBirthdayProps) {
  return (
    <section className="mb-4">
      <div className="md:grid md:grid-cols-2 md:gap-4">
        <p className="text-sm mb-2 md:mb-0">
          Add your birthday and enjoy rewards points and maybe a little
          something extra each year.
        </p>
        <div>
          <DatePicker
            className="flex flex-1"
            clearIcon={null}
            disabled={isUpdating}
            minDate={subYears(new Date(), 128)}
            maxDate={subYears(new Date(), 18)}
            onChange={(value: Date | null) => {
              onUpdateBirthDate(value)
            }}
            value={isDate(birthDate) ? new Date(birthDate!) : null}
          />
          <style global jsx>{`
            .react-date-picker__wrapper {
              border: none;
              font-family: inherit;
              font-size: 1.2rem;
            }
            .react-date-picker__wrapper input {
              display: inline-block;
              padding: 0rem 0.5rem;
            }
          `}</style>
        </div>
      </div>
    </section>
  )
}
